import { colors } from './settings'

export const getLifestyleColor = (topic = 'default') => {
    const topicName = topic.split('/')[1]
    switch (topicName) {
        case 'food':
            return colors.sevennews.lifestyleFood
        case 'real-estate':
            return colors.sevennews.lifestyleRealEstate
        case 'shopping':
            return colors.sevennews.lifestyleShopping
        case 'health-wellbeing':
            return colors.sevennews.lifestyleHealthWelbeing
        case 'travel':
            return colors.sevennews.lifestyleTravel
        case 'parenting':
            return colors.sevennews.lifestyleParenting
        case 'pets':
            return colors.sevennews.lifestylePets
        case 'big-brother-australia':
            return colors.sevennews.snentpurple
        default:
            return colors.sevennews.lifestyleDefault
    }
}
